import React from 'react';
import PropTypes from 'prop-types';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';

const styles = {
  typography: (theme) => ({
    padding: theme.spacing(2),
  }),
  triggerBtn: {
    position: 'absolute',
    top: '12px',
    right: '-8px'
  },
  popper: {
    zIndex: 100,
    marginLeft: '-19px',
    marginRight: '19px',
    paddingTop: '8px',
  },
  tooltip: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // Blaugrau-Fläche: im Dark-Modus die dunkle Stufe derselben Farbfamilie
    background: theme.palette.mode === 'dark' ? '#37474f' : '#cfd8dc'
  })
};

class InputInformation extends React.Component {
  state = {
    anchorEl: null,
    open: false,
  };

  handleClick = event => {
    const { currentTarget } = event;
    this.setState(state => ({
      anchorEl: currentTarget,
      open: !state.open,
    }));
  };

  render() {
    const { anchorEl, open } = this.state;
    const id = open ? 'simple-popper' : null;

    return (
      <React.Fragment>
        <IconButton
          sx={styles.triggerBtn}
          aria-describedby={id}
          variant="contained"
          onClick={this.handleClick}
          size="large">
          <Icon>info</Icon>
        </IconButton>
        <Popper id={id}
          sx={styles.popper}
          open={open}
          anchorEl={anchorEl}
          transition
          disablePortal
          >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper sx={styles.tooltip}>
                {this.props.content}
              </Paper>
            </Fade>
          )}
        </Popper>
      </React.Fragment>
    );
  }
}

InputInformation.propTypes = {
};

export default InputInformation;
